module.exports = __webpack_public_path__ + "static/media/skill6_neg_en.dacb58ea.txt";